import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const pub = axios.create({ baseURL: API });

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (c) => {
      const t = await getToken();
      if (t) c.headers.Authorization = `Bearer ${t}`;
      return c;
    });
    return inst;
  }, [getToken]);
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(", ");
  return e?.message || "Something went wrong";
}

export function useLoad(path, deps = []) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    if (!path) return;
    try {
      setData((await api.get(path)).data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, path, ...deps]);
  useEffect(() => {
    reload();
  }, [reload]);
  return [data, reload, error];
}

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export const SLOTS = ["morning", "afternoon", "night"];
export const PURPOSES = ["BP", "Sugar", "Thyroid", "Heart", "Calcium", "Cholesterol", "Antibiotic", "Pain", "Fever", "Gas", "Vitamin", "Other"];
export const FORMS = ["tablet", "capsule", "syrup", "drops", "injection", "inhaler", "ointment"];
export const FOODS = { before: "Before food", empty_stomach: "Empty stomach", after: "After food", bedtime: "Bedtime", none: "None" };
export const RESULTS = { answered: "Answered", not_answered: "Not answered", busy: "Busy", failed: "Failed", pending: "In progress" };
